import { TimeSheetTrackingState } from './types'

export const state: TimeSheetTrackingState = {
    filterTimeSheetTracking: {},
    timeSheetTrackings: [],
    timeSheetTrackingCount: 0,
    loading: false
}